/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface INutritionPlan {
  id?: string;
  planName?: string;
  description?: string | null;
  tmType?: string;
  microSec?: number;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  active?: boolean | null;
  tmRank?: number | null;
}

export const defaultValue: Readonly<INutritionPlan> = {
  active: false,
};
